import ReactPaginate from "react-paginate"
import "../index.css"
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react"

export const FilterPagination = ({ offset, setOffset, handlePageChange, pageCount }) => {
    return (
        <>
            <div className="d-flex align-items-start justify-content-center mt-0 gap-0">
                {/* First Page Button */}
                <button
                    onClick={() => setOffset(0)}
                    disabled={offset === 0}
                    className="first-last-btn"
                    style={{
                        padding: '0px 12px',
                        marginBottom: '3px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px',
                        height: "1.8rem",
                        backgroundColor: offset === 0 ? '#f8f9fa' : 'white',
                        color: offset === 0 ? '#6c757d' : '#7a3a5e',
                        cursor: offset === 0 ? 'not-allowed' : 'pointer',
                        opacity: offset === 0 ? 0.5 : 1
                    }}
                >
                    ««
                </button>

                {/* React Paginate */}
                <ReactPaginate
                    previousLabel={
                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <IconChevronLeft stroke={2} style={{ width: '16px', height: '16px' }} />
                            Previous
                        </span>
                    }
                    nextLabel={
                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            Next
                            <IconChevronRight stroke={2} style={{ width: '16px', height: '16px' }} />
                        </span>
                    }
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageChange}
                    forcePage={offset}
                    containerClassName="pagination d-flex align-items-start gap-0 mb-0"
                    pageClassName="page-filter-item"
                    pageLinkClassName="page-filter-link"
                    previousClassName="page-filter-previous"
                    previousLinkClassName="page-filter-previous-link"
                    nextClassName="page-filter-next"
                    nextLinkClassName="page-filter-next-link"
                    breakClassName="page-filter-item"
                    breakLinkClassName="page-filter-link"
                    activeClassName="active"
                    disabledClassName="disabled"
                />

                {/* Last Page Button */}
                <button
                    onClick={() => setOffset(pageCount - 1)}
                    disabled={offset === pageCount - 1}
                    className="first-last-btn"
                    style={{
                        padding: '0px 15px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px',
                        height: "1.8rem",
                        marginBottom: '3px',
                        backgroundColor: offset === pageCount - 1 ? '#f8f9fa' : 'white',
                        color: offset === pageCount - 1 ? '#6c757d' : '#7a3a5e',
                        cursor: offset === pageCount - 1 ? 'not-allowed' : 'pointer',
                        opacity: offset === pageCount - 1 ? 0.5 : 1
                    }}
                >
                    »»
                </button>
            </div>
            <style jsx>{`
                .pagination {
                    list-style: none !important;
                    padding: 0 !important;
                    margin: 0 !important;
                }

                .page-filter-item {
                    display: inline-block !important;
                }

                .page-filter-previous,
                .page-filter-next {
                    display: inline-block !important;
                }

                .page-filter-link {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    padding: 5px 12px !important;
                    margin: 0 2px !important;
                    height: 1.8rem;
                    text-decoration: none !important;
                    color: #7a3a5e !important;
                    background-color: white !important;
                    border: 1px solid #dee2e6 !important;
                    border-radius: 4px !important;
                    cursor: pointer !important;
                    transition: all 0.2s ease !important;
                    font-size: 14px !important;
                    line-height: 1 !important;
                }

                /* Previous/Next specific links */
                .page-filter-previous-link,
                .page-filter-next-link {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    padding: 5px 12px !important;
                    margin: 0 2px !important;
                    height: 1.8rem;
                    text-decoration: none !important;
                    color: #7a3a5e !important;
                    background-color: white !important;
                    border: 1px solid #dee2e6 !important;
                    border-radius: 4px !important;
                    cursor: pointer !important;
                    transition: all 0.2s ease !important;
                    font-size: 14px !important;
                    line-height: 1 !important;
                }

                .page-filter-item.active .page-filter-link {
                    background-color: #7a3a5e !important;
                    border-color: #7a3a5e !important;
                    color: white !important;
                }

                /* Disabled states - match first/last buttons exactly */
                .page-filter-previous.disabled .page-filter-previous-link,
                .page-filter-next.disabled .page-filter-next-link,
                .page-filter-item.disabled .page-filter-link {
                    background-color: #f8f9fa !important;
                    color: #6c757d !important;
                    cursor: not-allowed !important;
                    opacity: 0.5 !important;
                    border-color: #dee2e6 !important;
                }

                /* Hover states for enabled buttons only */
                .page-filter-link:hover:not(.page-filter-item.disabled .page-filter-link),
                .page-filter-previous-link:hover:not(.page-filter-previous.disabled .page-filter-previous-link),
                .page-filter-next-link:hover:not(.page-filter-next.disabled .page-filter-next-link) {
                    background-color: #f8f9fa !important;
                    border-color: #7a3a5e !important;
                    color: #7a3a5e !important;
                }

                /* Remove all focus styles and replace with our own */
                .page-filter-link:focus,
                .page-filter-previous-link:focus,
                .page-filter-next-link:focus {
                    outline: none !important;
                    box-shadow: none !important;
                    border-color: #dee2e6 !important;
                }

                /* Active state for buttons when clicked */
                .page-filter-link:active:not(.page-filter-item.disabled .page-filter-link),
                .page-filter-previous-link:active:not(.page-filter-previous.disabled .page-filter-previous-link),
                .page-filter-next-link:active:not(.page-filter-next.disabled .page-filter-next-link) {
                    background-color: #f8f9fa !important;
                    border-color: #7a3a5e !important;
                }

                /* Ensure no hover effects on disabled buttons */
                .page-filter-previous.disabled .page-filter-previous-link:hover,
                .page-filter-next.disabled .page-filter-next-link:hover,
                .page-filter-item.disabled .page-filter-link:hover {
                    background-color: #f8f9fa !important;
                    border-color: #dee2e6 !important;
                    color: #6c757d !important;
                }

                .first-last-btn {
                    transition: all 0.2s ease !important;
                    font-weight: 500 !important;
                }

                .first-last-btn:hover:not(:disabled) {
                    background-color: #f8f9fa !important;
                    border-color: #7a3a5e !important;
                    color: #7a3a5e !important;
                }

                /* Remove any browser default styles */
                .page-filter-previous-link,
                .page-filter-next-link,
                .page-filter-link {
                    -webkit-appearance: none !important;
                    -moz-appearance: none !important;
                    appearance: none !important;
                }
            `}</style>
        </>
    )
}